import { render, staticRenderFns } from "./ThemeConfig.vue?vue&type=template&id=a2d5b786&scoped=true&"
import script from "./ThemeConfig.vue?vue&type=script&lang=js&"
export * from "./ThemeConfig.vue?vue&type=script&lang=js&"
import style0 from "./ThemeConfig.vue?vue&type=style&index=0&id=a2d5b786&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d5b786",
  null
  
)

export default component.exports